import { useEffect } from 'react';
import { getSelectionRect } from 'libs/common/utils';

var useLinkToolbar = function useLinkToolbar(editorRef, toolbarRef, editorHasFocus) {
  useEffect(function () {
    var nativeSelection = window.getSelection();
    /**
     * Toolbar position is not updated when:
     * - refs are not initialized
     * - editor is not focused
     * - the browser native selection is null
     */

    if (!editorRef.current || !toolbarRef.current || !editorHasFocus || nativeSelection === null || nativeSelection.rangeCount === 0) {
      return;
    }

    var selectionBoundary = getSelectionRect(nativeSelection);

    if (selectionBoundary === undefined) {
      return;
    }

    var toolbarBoundary = toolbarRef.current.getBoundingClientRect();
    var parentBoundary = editorRef.current.editor.getBoundingClientRect();
    /*
     * Main logic for setting the toolbar position.
     */

    toolbarRef.current.style.bottom = "".concat(parentBoundary.bottom - selectionBoundary.top + 12, "px"); // The left side of the tooltip should be:
    // center of selection relative to parent - half width of toolbar

    var selectionCenter = selectionBoundary.left + selectionBoundary.width / 2 - parentBoundary.left;
    var left = selectionCenter - toolbarBoundary.width / 2;
    var screenLeft = parentBoundary.left + left;

    if (screenLeft < 0) {
      // If the toolbar would be off-screen
      // move it as far left as it can without going off-screen
      left = -parentBoundary.left;
    }

    toolbarRef.current.style.left = "".concat(left, "px");
  }, [editorRef, toolbarRef, editorHasFocus]);
};

export default useLinkToolbar;